export default "__VITE_ASSET__DZuu660x__"